import { ETHEREUM_NETWORK } from "./env"

export const LOCK_TIMES = [
  { period: 39, multiplier: 16 },
  { period: 24, multiplier: 10 },
  { period: 8, multiplier: 3 },
] // specified in weeks

export const BITCOIN_NAME_UNLOCK = 0.05
export const BITCOIN_INVITE_CODES_UNLOCK = 0.01
export const MAX_DISPLAYED_MATS = 1_000_000
export const THRESHOLD_FEE = 0.002 // 0.2%
export const PORTAL_WITHDRAWAL_GAS_USAGE = 55_000 // average value from events
export const TBTC_BRIDGE_GAS_USAGE = 190_000 // average value from events
export const LEADERBOARD_FETCH_CHUNK = 20

export const DATABASE_DECIMALS_COUNT = 18

export const FRIENDLY_DECIMALS_AMOUNT = 6
export const DEPOSIT_BOX_FRIENDLY_DECIMALS_AMOUNT = 4

export const VAULTS_DAILY_MATS_REWARD = 100_000

// Minimum BTC deposit amount that can be later withdrawn on sepolia
export const BITCOIN_SEPOLIA_MINIMUM_DEPOSIT_TO_WITHDRAW = 0.11
// Minimum BTC deposit amount that can be withdrawn (after fees)
export const BITCOIN_MINIMUM_WITHDRAWABLE_AMOUNT = 0.009

// Min BTC deposit - 0.011 (mainnet) and 0.00001 (sepolia)
export const BITCOIN_MIN_DEPOSIT =
  ETHEREUM_NETWORK === "mainnet" ? 0.01 : 0.0001
export const BITCOIN_MIN_DECIMALS = ETHEREUM_NETWORK === "mainnet" ? 2 : 4
